import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useSelector } from 'react-redux';
import useTranslate from 'hooks/useTranslate';
import { getUser } from 'state/session/selectors';
import { getScreenName } from 'state/screen/selectors';
import { CreditCardFormModal } from 'components/CreditCardForm';
import { getCreditAddCardSource } from 'libs/utils/threeDS2';
import { Screen } from 'constants/tracking/screens';
import useTrackViewExtraServiceCheckout from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";

const ExtraServiceCreditCardFormModal = _ref => {
  let {
    show,
    onBack,
    orderId,
    orderType,
    onSuccess,
    addCardSourceParams,
    isCardAddError = false
  } = _ref;
  const translateRedirectError = useTranslate('credit_card_add.threeds2.errors');
  const user = useSelector(getUser);
  const currentPage = useSelector(getScreenName);
  const errorMessage = isCardAddError ? translateRedirectError('redirect_return_error') : undefined;
  useTrackViewExtraServiceCheckout({
    shouldTrack: show,
    orderId,
    orderType,
    screen: Screen.CreditCardAdd
  });
  if (!user || !orderId) return null;
  return /*#__PURE__*/_jsx(CreditCardFormModal, {
    show: show,
    allowSingleUse: true,
    errorMessage: errorMessage,
    source: getCreditAddCardSource(_objectSpread({
      orderId,
      userId: user.id,
      page: currentPage
    }, addCardSourceParams)),
    trackingTargetDetails: {
      service_order_id: orderId,
      type: orderType
    },
    onCreditCardAddSuccess: onSuccess,
    onBack: onBack
  });
};

export default ExtraServiceCreditCardFormModal;